/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Reservations_Card_DescriptionInputs */

const en_inventory_reservations_card_description = /** @type {(inputs: Inventory_Reservations_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract draft holds are already removed from available inventory. Reserved counts only active checkout or manual holds.`)
};

const es_inventory_reservations_card_description = /** @type {(inputs: Inventory_Reservations_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los borradores de contrato ya se descuentan del inventario disponible. Reservado solo cuenta apartados activos de checkout o manuales.`)
};

/**
* | output |
* | --- |
* | "Contract draft holds are already removed from available inventory. Reserved counts only active checkout or manual holds." |
*
* @param {Inventory_Reservations_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_reservations_card_description = /** @type {((inputs?: Inventory_Reservations_Card_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Reservations_Card_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_reservations_card_description(inputs)
	return es_inventory_reservations_card_description(inputs)
});